import { createAction } from '@reduxjs/toolkit';
import getCurrentDirname from '~/utils/get-current-dirname/get-current-dirname';

const prefix = getCurrentDirname(__dirname);

export const redirectUser = createAction<{
  path?: string;
  search?: string;
  pushToHistory?: boolean;
}>(`${prefix}/REDIRECT_USER`);
